module.exports = __webpack_public_path__ + "static/media/everyday_digital_footy2024.78ba568b.png";